//账号管理模块

//引入接口文档
import req from '@/utils/req.js'

//侧边菜单路由接口
export function api_routerjurisdiction() {
  return req.get('/admin/resource/user-resource')
}
//获取用户答题答案
export function dsicmSurvey(params) {
  return req.get(`/dsicm-survey/web/surveys/${params.surveyId}/person/${params.personId}/answers/${params.feedbackId}`)
}
//问卷分页查询-模糊查询
export function selectSurveys(params) {
  return req.get(`/dsicm-survey/oss/surveys`, params)
}

//医生主动结束问诊
export function doctorEndInquiry(params) {
  return req.get(`/admin/inquiry-info/doctorEndInquiry`, params)
}

//患者方案任务查询
export function schemeTask(params) {
  return req.get(`/admin/patient-task/schemeTask`, params)
}
// 用户机构关联列表
export function userAuth(params) {
  return req.post(`/admin/user-auth/search`, params)
}
//用户切换登录 
export function switchUser(params) {
  return req.post(`/admin/user-auth/switchUser`, params)
}
// 线下机构
export function plateFormAll(params = {}) {
  return req.post(`/admin/hospital/listPullDown`, params)
}
// 线下启用状态机构
export function plateFormOn() {
  return req.post(`/admin/hospital/list`, {})
}